var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileImageSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.001,
    height: 42.001,
    viewBox: "0 0 56.001 42.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-image-svgrepo-com",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M49,3H7a7.021,7.021,0,0,0-7,7V38a7.009,7.009,0,0,0,6.3,6.953c.233.023.467.047.7.047H49a3.192,3.192,0,0,0,.677-.047c.07,0,.14-.023.21-.023A7,7,0,0,0,56,38V10A7.021,7.021,0,0,0,49,3Zm2.333,31.571L46.178,24.257a4.7,4.7,0,0,0-2.847-2.4A5.225,5.225,0,0,0,42,21.667a4.7,4.7,0,0,0-2.357.63L24.687,31.024l-5.74-3.9a4.644,4.644,0,0,0-2.613-.793,4.572,4.572,0,0,0-3.29,1.377L4.667,36.087V10A2.34,2.34,0,0,1,7,7.667H49A2.34,2.34,0,0,1,51.335,10Z",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(21.001 14)",
    fill: "#afafaf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImageSvgrepoCom);
export default __webpack_public_path__ + "static/media/file-image-svgrepo-com.e3dc27bffe6a108df947c1412c071642.svg";
export { ForwardRef as ReactComponent };